import { styled } from "styled-components";

export const StyledModalText = styled.p`
  margin: 0 0 1rem 0;
  font-size: 1.1rem;
  line-height: 1.6rem;
  color: ${({ theme }) => theme.colors.textBright};
`;
